
export const BuyerBundlesQuery = new TypedDocumentString(`
    query BuyerBundlesQuery($input: InputBuyerBundles!) {
  buyerBundles(input: $input) {
    cursorNext
    items {
      ...SellerBundle
      __typename
    }
    __typename
  }
}
    fragment ImageTagged on ImageTagged {
  ratio
  type
  img {
    ...Image
    __typename
  }
  tags {
    x
    y
    productId
    groupId
    profileId
    __typename
  }
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment PriceVariantBundle on PriceVariantBundle {
  entryId
  minQty
  entries {
    groupId
    variantIds
    __typename
  }
  __typename
}
fragment SellerBundle on SellerBundle {
  _id
  title {
    value
    __typename
  }
  description {
    value
    __typename
  }
  discountId
  imageTagged {
    ...ImageTagged
    __typename
  }
  percentValue
  entries {
    ...PriceVariantBundle
    __typename
  }
  __typename
}`, {"hash":"10edd87acbeee34880df59f44f91fc9062faaf8c5f879d6113b7e709f836359f"});